import { Injectable } from '@angular/core';
import { ProjectEstimate } from '@app/shared/models';
import { Subject } from 'rxjs';
import { EstimateTab } from '../models/estimate-tab';

@Injectable({ providedIn: 'root'})
export class EstimateTabService {
  private estimateTabSource = new Subject<EstimateTab>();

  public estimateTab$ = this.estimateTabSource.asObservable();
  public estimateTabUpdated$ = new Subject();

  public estimateTab(tab: EstimateTab) {
    this.estimateTabSource.next(tab);
  }

  public updateTabs(estimates: ProjectEstimate[]) {
    this.estimateTabUpdated$.next(estimates);
  }
}